export const uiuxFAQs = [
  {
    id: 1,
    question: "Welche Tools und Technologien verwenden Sie für das UI/UX Design?",
    answer:
      "Als Designagentur setzen wir auf branchenführende Software wie Figma, Adobe XD und Sketch. Diese Tools ermöglichen uns, innovative und ansprechende Benutzeroberflächen zu entwickeln, schnelle Iterationen durchzuführen und detaillierte Prototypen zu erstellen – alles, um Ihnen hochwertige, maßgeschneiderte digitale Erlebnisse zu bieten.",
  },
  {
    id: 2,
    question: "Wie gestaltet sich Ihr Designprozess in der Zusammenarbeit mit Ihren Kunden?",
    answer:
      "Unser Prozess ist stark kundenorientiert und transparent. Wir beginnen mit intensiven Workshops und ausführlicher Recherche, um Ihre Ziele, Zielgruppen und Anforderungen zu verstehen. In regelmäßigen Abstimmungen präsentieren wir erste Konzepte und Zwischenstände, um das Design iterativ anhand Ihres Feedbacks zu verfeinern – von der Konzeptphase bis zum finalen Interface.",
  },
  {
    id: 3,
    question: "Was unterscheidet UI von UX und warum sind beide entscheidend?",
    answer:
      "UI (User Interface) fokussiert sich auf die visuelle Gestaltung und Interaktionselemente, während UX (User Experience) das gesamte Nutzungserlebnis umfasst – von der Informationsarchitektur bis zur Benutzerfreundlichkeit. Beide Disziplinen sind untrennbar, da ein ansprechendes Design nur dann Erfolg hat, wenn es auch intuitiv und funktional ist.",
  },
  {
    id: 4,
    question: "Wie integrieren Sie Kunden- und Benutzerfeedback in den Designprozess?",
    answer:
      "Feedback ist ein zentraler Bestandteil unseres iterativen Ansatzes. Wir führen regelmäßig Usability-Tests, A/B-Tests und persönliche Feedbackrunden durch, um sicherzustellen, dass das Design stets an den Bedürfnissen der Nutzer ausgerichtet ist. Diese kontinuierliche Rückkopplung ermöglicht es uns, das finale Produkt optimal zu gestalten.",
  },
  {
    id: 5,
    question: "Welche Bedeutung hat Barrierefreiheit in Ihren Projekten?",
    answer:
      "Barrierefreiheit ist für uns essenziell, um inklusive digitale Erlebnisse zu schaffen. Wir richten unsere Designs nach den WCAG 2.1-Richtlinien aus, um sicherzustellen, dass alle Nutzer – unabhängig von ihren individuellen Fähigkeiten – einen uneingeschränkten Zugang zu Ihren Inhalten haben. Dies steigert nicht nur die Nutzerzufriedenheit, sondern auch die Reichweite Ihrer digitalen Produkte.",
  },
  {
    id: 6,
    question: "Wie lange dauert in der Regel ein UI/UX Designprojekt?",
    answer:
      "Die Dauer variiert je nach Komplexität und Umfang des Projekts. In der Regel planen wir für komplette UI/UX-Projekte zwischen 4 und 8 Wochen ein. Dabei fließen alle Phasen von der initialen Recherche über Konzeptentwicklung, Prototyping, Usability-Tests bis hin zur finalen Optimierung in den Zeitplan ein.",
  },
  {
    id: 7,
    question: "Bieten Sie auch fortlaufenden Support und Optimierungen nach Projektabschluss an?",
    answer:
      "Ja, unser Service endet nicht mit der Fertigstellung des Designs. Wir bieten umfassenden After-Sales-Support, inklusive regelmäßiger Updates, Monitoring und Optimierungen basierend auf Nutzerfeedback, um sicherzustellen, dass Ihre digitale Lösung stets auf dem neuesten Stand bleibt und kontinuierlich verbessert wird.",
  },
];

export const uiuxIntro = {
  title: "UI/UX Design FAQs",
  subtitle: "Antworten auf Ihre Fragen zu digitalen Designlösungen",
  description:
    "Hier finden Sie detaillierte Informationen zu unseren UI/UX Design Services. Sollten Sie weitere Fragen haben, stehen wir Ihnen jederzeit zur Verfügung, um gemeinsam die optimale Lösung für Ihre digitalen Projekte zu realisieren.",
};
